$(function() {

  var dionAnimation = bodymovin.loadAnimation({
    container: document.getElementById('dion-animation'), // Required
    path: '//dionnevitrek.com/cdn/shop/t/21/assets/dion-animation.json?v=9181511071978536791761911377', // Required
    renderer: 'svg', // Required
    loop: false, // Optional
    autoplay: false,
  })

  var nevitrekAnimation = bodymovin.loadAnimation({
    container: document.getElementById('nevitrek-animation'), // Required
    path: '//dionnevitrek.com/cdn/shop/t/21/assets/nevitrek-animation.json?v=116986065027095006681761911377', // Required
    renderer: 'svg', // Required
    loop: false, // Optional
    autoplay: false,
  })

  var mapHeartAnimation = bodymovin.loadAnimation({
    container: document.getElementById('map-heart-animation'), // Required
    path: '//dionnevitrek.com/cdn/shop/t/21/assets/map-heart-animation.json?v=157473950919827308511761911377', // Required
    renderer: 'svg', // Required
    loop: false, // Optional
    autoplay: false,
  })

  // NAV FADE IN
  var nav_fade_in = new TimelineMax();

  nav_fade_in.from('header .logo img', 1.5, { top: -300, ease: Power4.easeOut }, 0)
    .from("header .top-bar li:nth-of-type(1)", 1, { opacity: 0, ease: Power4.easeOut },  '-=1')
    .from("header nav li:nth-of-type(1)", 1, { opacity: 0, ease: Power4.easeOut }, '-=1')
    .from("header .top-bar li:nth-of-type(2)", 1, { opacity: 0, ease: Power4.easeOut }, '.7')
    .from("header nav li:nth-of-type(2)", 1, { opacity: 0, ease: Power4.easeOut }, '.7')
    .from("header nav li:nth-of-type(3)", 1, { opacity: 0, ease: Power4.easeOut }, '.9')
    // .from("header nav li:nth-of-type(4)", 1, { opacity: 0, ease: Power4.easeOut }, '1.1')
    .from("header .top-bar li:nth-of-type(3)", 1, { opacity: 0, ease: Power4.easeOut }, '1.1')
    .from("header nav .search", 1, { opacity: 0, ease: Power4.easeOut }, '1.3')
    .from("header .top-bar li:nth-of-type(4)", 1, { opacity: 0, ease: Power4.easeOut }, '1.3')
    .from("header nav .cart-icon", 1, { opacity: 0, ease: Power4.easeOut }, '1.3');

  // HERO SPLIT TEXT
  var HeroTitle = {
  el: document.getElementById('header-title'),
  textTl: new TimelineLite(),

  init: function() {
      this.mySplitText = new SplitText(this.el, {type:'lines'});
      this.lines = this.mySplitText.lines;

      this.map();
      this.animate();
  },

  map: function() {
      this.lines.map(function(line){
          var parent = line.parentNode,
              wrapper = document.createElement('div');
          wrapper.className = 'mask';
          parent.replaceChild(wrapper, line);
          wrapper.appendChild(line);
          return wrapper;
      });
  },

  animate: function() {
      this.textTl.staggerFrom(this.lines, 1, {
          opacity:0,
          y:80,
          rotation: 30,
          force3D:true,
          transformOrigin:'0 0',
          ease: Power4.easeOut
      }, 0.05, '+=1.2');
    }
  };

  HeroTitle.init();

  // HOME HERO CONTENT / BUTTON FADE IN
  var home_hero_fade_in = new TimelineMax();

  home_hero_fade_in.from('.home-slider h3', 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '1.8')
    .from(".home-slider .hero-btn", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '2');

  // SCROLLMAGIC START

  // Controller
  var controller = new ScrollMagic.Controller();

  // EXPLORE HEADER FADE IN
  var explore_fade_in = new TimelineMax();

  explore_fade_in.from('.headline', 1.5, { top: 150, opacity: 0, ease: Power4.easeOut }, 0)
    .from('.explore h1', 1.5, { top: 40, opacity: 0, ease: Power4.easeOut }, 0)
    .to('#powder-left', 2, { transform: 'translateX(-100%)', opacity: 0, ease: Power4.easeOut}, 0)
    .to('#powder-right', 2, { transform: 'translateX(100%)', opacity: 0, ease: Power4.easeOut}, 0);

  var explore_fade_in_scene = new ScrollMagic.Scene({
    triggerElement: '.explore',
    reverse: false,
  })
  .setTween(explore_fade_in)
  // .addIndicators()
  .addTo(controller);

  // DION MODULE FADE IN
  var dion_module_fade_in = new TimelineMax();

  dion_module_fade_in.from('.dion-module .logo', 1, { top: 20, opacity: 0, ease: Power4.easeOut }, 0)
    .from(".dion-module h1", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".dion-module .img-container", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".dion-module p", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.6')
    .from(".dion-module button", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.8')
    .call(playAnim, [dionAnimation], this, 0);

  var dion_module_fade_in_scene = new ScrollMagic.Scene({
    triggerElement: '.dion-module',
    offset: 150,
    reverse: false
  })
  .setTween(dion_module_fade_in)
  // .addIndicators()
  .addTo(controller);

  // NEVITREK MODULE FADE IN
  var nevitrek_animation = new TimelineMax();

  nevitrek_animation.from('.nevitrek-module .logo', 1, { top: 20, opacity: 0, ease: Power4.easeOut }, 0)
    .from(".nevitrek-module h1", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".nevitrek-module .img-container", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".nevitrek-module p", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.6')
    .from(".nevitrek-module button", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.8')
    .call(playAnim, [nevitrekAnimation], this, 0);;

  var nevitrek_animation_scene = new ScrollMagic.Scene({
    triggerElement: '.nevitrek-module',
    offset: 150,
    reverse: false
  })
  .setTween(nevitrek_animation)
  // .addIndicators()
  .addTo(controller);

  // OUR STORY FADE IN
  var our_story_fade_in = new TimelineMax();

  our_story_fade_in.from('.our-story .stamp', 1, { top: 20, opacity: 0, ease: Power4.easeOut }, 0)
    .from(".our-story h4", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".our-story .img-container", 2, { opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".our-story h1", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.6')
    .from(".our-story p", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.8')
    .from(".our-story button", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '1')
    .call(playAnim, [mapHeartAnimation], this, 0);

  var our_story_fade_in_scene = new ScrollMagic.Scene({
    // duration: $(window).height(),
    triggerElement: '.our-story',
    offset: 150,
    reverse: false,

  })
  .setTween(our_story_fade_in)
  // .addIndicators()
  .addTo(controller);


  // QUESTIONS FADE IN
  var questions_fade_in = new TimelineMax();

  questions_fade_in.from('.questions h2', 1, { top: 20, opacity: 0, ease: Power4.easeOut }, 0)
    .from(".questions p", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.4')
    .from(".questions button", 1, { top: 20, opacity: 0, ease: Power4.easeOut }, '.6');

  var questions_fade_in_scene = new ScrollMagic.Scene({
    // duration: $(window).height(),
    triggerElement: '.questions',
    offset: 150,
    reverse: false,

  })
  .setTween(questions_fade_in)
  // .addIndicators()
  .addTo(controller);

  // EXPLORE COLUMN HOVER EFFECT
  $exploreCol = $('.explore-col')

  $($exploreCol).hover(

    function() {

      $hoverCol = $(this).find('.product-cta');

      TweenMax.to($hoverCol, 0.5, { top: -50, ease: Power4.easeOut });


    }, function() {

      TweenMax.to($hoverCol, 0.5, { top: 0, ease: Power4.easeOut });

    }

  );

  function playAnim(name) {
    name.goToAndPlay(0, true)
  }

});
